module.exports = __webpack_public_path__ + "static/media/open_bower_android.ded0420e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/open_bower_android.png
// module id = 323
// module chunks = 0